import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, Shield, Download, MonitorSmartphone } from 'lucide-react';
export function Hero() {
  return <section className="relative flex items-start pt-2 md:pt-3 pb-4 overflow-hidden" data-id="element-86">
      <div className="container mx-auto px-6 relative z-10" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-88">
          <div className="flex justify-center" data-id="element-89">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-500/10 border border-orange-500/20 text-orange-400 font-semibold tracking-wide mb-2 text-[12px]" data-id="element-90">
              <Zap className="w-4 h-4" data-id="element-91" />
              ATENCIÓN: FONOAUDIÓLOGOS/AS
            </div>
          </div>

          <h1 className="md:text-5xl lg:text-6xl mb-1 font-[900] font-[Montserrat,_sans-serif] text-center text-[24px]" data-id="element-92">
            Todo tu material fonoaudiológico,{' '}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-fuchsia-400 via-purple-400 to-violet-400" data-id="element-93">
              resuelto
            </span>{' '}
            en 7 días o menos.
          </h1>

          {/* Image directly below the title */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mb-2" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/xcMMFkSGfftYMou4g1pEvn/Fono_mockup.png" alt="MegaPack Fonoaudiología Mockup" loading="lazy" className="w-full h-auto relative z-10 max-w-2xl mx-auto md:px-[60px] pl-[40px] pr-[40px]" data-id="element-95" />
          </motion.div>

          <div className="glass-card rounded-2xl p-3 border-l-4 border-l-orange-500 mb-3" data-id="element-96">
            <p className="text-gray-200 text-[16px] font-[500] font-['Open_Sans',_sans-serif] text-center" data-id="element-97">
              El recurso práctico para ordenar tu trabajo clínico y elevar tu
              imagen desde el primer día.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 items-center justify-center mb-3" data-id="element-98">
            <motion.a href="#premium-cta" onClick={e => {
            e.preventDefault();
            const target = document.getElementById('premium-cta');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          }} whileHover={{
            scale: 1.04,
            y: -2
          }} whileTap={{
            scale: 0.98
          }} className="inline-block w-full sm:w-auto text-center px-8 py-4 rounded-2xl bg-gradient-primary text-white font-extrabold text-lg uppercase tracking-wide ring-2 ring-orange-400/60 ring-offset-2 ring-offset-black shadow-[0_0_40px_rgba(168,85,247,0.55)] transition-all cursor-pointer" data-id="element-99">
              QUIERO ACCEDER AL MEGAPACK AHORA
            </motion.a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-sm text-gray-400 font-medium" data-id="element-100">
            <div className="flex items-center gap-2" data-id="element-101">
              <Zap className="w-4 h-4 text-orange-500" data-id="element-102" /> Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-103">
              <Shield className="w-4 h-4 text-orange-500" data-id="element-104" /> Pago único
            </div>
            <div className="flex items-center gap-2" data-id="element-105">
              <Download className="w-4 h-4 text-orange-500" data-id="element-106" /> Material digital
            </div>
            <div className="flex items-center gap-2" data-id="element-107">
              <MonitorSmartphone className="w-4 h-4 text-orange-500" data-id="element-108" /> Uso
              profesional
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}